module.exports = __webpack_public_path__ + "img/1448195916.f6636ea3.jpg";